import React from "react";
import { Container } from "reactstrap";
import { Progress } from "antd";
import { developmentProjectType, ResourceType } from "utils/common-options";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
const ProjectOverview = ({ projectDetail }) => {
  return (
    <React.Fragment>
      <div className=" mb-3">
        <Container fluid>
          <div className="row">
            <div
              className={`ps-0 ${
                projectDetail.project_type !== 3 ? "col-lg-7" : "col-lg-12"
              }`}
            >
              <div className="card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1 overflow-hidden">
                      <h5 className="text-purple fw-bold font-size-18">
                        {projectDetail?.project_name}
                      </h5>
                      <p>
                        <strong>Project Type</strong> :{" "}
                        {
                          developmentProjectType?.find(
                            (obj) => obj?.value == projectDetail?.project_type
                          )?.label
                        }
                        , <strong>Customer</strong> : Ambrella Consultancy
                      </p>
                    </div>
                  </div>
                  <h5 className="font-size-15 mt-4">Project Description :</h5>
                  <p
                    className="text-muted"
                    dangerouslySetInnerHTML={{
                      __html: projectDetail?.description,
                    }}
                  />

                  <div className="d-flex gap-4 mt-5 ">
                    <div className="text-muted  ">
                      <p>
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                        <span className="text-purple fw-bold">
                          Project Belongs
                        </span>{" "}
                        : {projectDetail?.location}
                      </p>
                      {/* <p>
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                        <span className="text-purple fw-bold">
                          Resource Type
                        </span>
                        :{" "}
                        {
                          ResourceType?.find(
                            (obj) => obj?.value == projectDetail?.billingtype
                          )?.label
                        }
                      </p> */}
                      <p className="mb-0">
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                        <span className="text-purple fw-bold">
                          Project Industry
                        </span>{" "}
                        : Information Technology
                      </p>
                    </div>
                    <div className="info_box_1"></div>
                    <div className="text-muted ">
                      <p>
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                        <span className="text-purple fw-bold">
                          Key Account Manager
                        </span>{" "}
                        : {projectDetail?.kam_name}
                      </p>
                      <p>
                        <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                        <span className="text-purple fw-bold">
                          Scrum Master
                        </span>
                        : {projectDetail?.scrum_mastername}
                      </p>
                    </div>
                  </div>

                  <div className="task-dates row mt-4">
                    <div className="col-3 col-sm-3">
                      <div className="mt-4">
                        <h5 className="font-size-14">
                          <i className="bx bx-calendar me-1 text-primary"></i>{" "}
                          Start Date
                        </h5>
                        <p className="text-muted mb-0">
                          {moment(projectDetail?.startdate).format(
                            "DD MMM, YYYY"
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="col-3 col-sm-3">
                      <div className="mt-4">
                        <h5 className="font-size-14">
                          <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                          Est. End Date
                        </h5>
                        <p className="text-muted mb-0">
                          {moment(projectDetail?.enddate).format(
                            "DD MMM, YYYY"
                          ) || "-"}
                        </p>
                      </div>
                    </div>
                    <div className="col-3 col-sm-3">
                      <div className="mt-4">
                        <h5 className="font-size-14">
                          <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                          Number Of Hours
                        </h5>
                        <p className="text-muted mb-0">
                          {projectDetail?.no_of_weeks} hours
                        </p>
                      </div>
                    </div>
                    <div className="col-3 col-sm-3 ps-0">
                      <div className="mt-4">
                        <h5 className="font-size-14">
                          <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                          Delivery Before Date
                        </h5>
                        <p className="text-muted mb-0">
                          {moment(projectDetail?.deliverydatebefore).format(
                            "DD MMM, YYYY"
                          ) || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* {secureLocalStorage.getItem("auth_role") == 9 ||
                  secureLocalStorage.getItem("auth_role") == 10 ||
                  secureLocalStorage.getItem("auth_role") == 22 ||
                  secureLocalStorage.getItem("auth_role") == 4 ||
                  secureLocalStorage.getItem("auth_role") == 11 ||
                  secureLocalStorage.getItem("auth_role") == 1 ||
                  secureLocalStorage.getItem("auth_role") == 18 ? (
                    <>
                      <p className="mt-4 pt-3 mb-0">
                        <span className="text-purple fw-bold">
                          Payment Schedule
                        </span>
                      </p>
                      <div className="task-dates row ">
                        {projectDetail?.payment_schedule?.map((obj, i) => {
                          const dates =
                            projectDetail?.completion_dates?.split(",")[i];
                          return (
                            <div className="col-3 col-sm-3" key={i}>
                              <div className="mt-3">
                                <h5 className="font-size-14">
                                  <i className="bx bx-calendar me-1 text-primary"></i>{" "}
                                  {obj}
                                </h5>
                                <p className="text-muted mb-0">
                                  {moment(dates).format("DD MMM, YYYY")}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  ) : null} */}
                </div>
              </div>
            </div>
            {projectDetail.project_type !== 3 && (
              <div className="col-lg-5 pe-0">
                <div className="card">
                  <div className="card-body">
                    <div className="responsive-table">
                      <h5 className="mb-3">Actual Hours Details</h5>

                      <table className="table table-bordered mb-0 mt-3 table-hover">
                        <thead>
                          <tr>
                            <th>Allocation Name</th>
                            <th>Approx %</th>
                            <th>Hours</th>
                          </tr>
                        </thead>

                        <tbody>
                          {/* TOTAL HOURS */}
                          <tr className="bg-light-purple">
                            <td className="col-5">
                              <strong className="text-purple fs-5">
                                Total Hours
                              </strong>
                            </td>
                            <td className="col-1 text-center">100 %</td>
                            <td className="col-2">
                              <input
                                disabled
                                type="number"
                                className="form-control text-center"
                                value={projectDetail?.total_hrs}
                              />
                            </td>
                          </tr>

                          {/* PLANNING */}
                          <tr>
                            <td>Planning</td>
                            <td className="text-center">
                              {Math.floor(
                                (projectDetail?.planning /
                                  projectDetail?.total_hrs) *
                                  100
                              )}{" "}
                              %
                            </td>
                            <td>
                              <input
                                disabled
                                type="number"
                                className="form-control text-center"
                                value={projectDetail?.planning}
                              />
                            </td>
                          </tr>

                          {/* DESIGNING */}
                          <tr>
                            <td>Designing</td>
                            <td className="text-center">
                              {Math.floor(
                                (projectDetail?.designing /
                                  projectDetail?.total_hrs) *
                                  100
                              )}{" "}
                              %
                            </td>
                            <td>
                              <input
                                disabled
                                type="number"
                                className="form-control text-center"
                                value={projectDetail?.designing}
                              />
                            </td>
                          </tr>

                          {/* DEVELOPMENT */}
                          <tr>
                            <td>Development</td>
                            <td className="text-center">
                              {Math.floor(
                                (projectDetail?.development /
                                  projectDetail?.total_hrs) *
                                  100
                              )}{" "}
                              %
                            </td>
                            <td>
                              <input
                                disabled
                                type="number"
                                className="form-control text-center"
                                value={projectDetail?.development}
                              />
                            </td>
                          </tr>

                          {/* TESTING */}
                          <tr>
                            <td>Testing</td>
                            <td className="text-center">
                              {Math.floor(
                                (projectDetail?.testing /
                                  projectDetail?.total_hrs) *
                                  100
                              )}{" "}
                              %
                            </td>
                            <td>
                              <input
                                disabled
                                type="number"
                                className="form-control text-center"
                                value={projectDetail?.testing}
                              />
                            </td>
                          </tr>

                          {/* DEPLOYMENT */}
                          <tr>
                            <td>Deployment</td>
                            <td className="text-center">
                              {Math.floor(
                                (projectDetail?.deployment /
                                  projectDetail?.total_hrs) *
                                  100
                              )}{" "}
                              %
                            </td>
                            <td>
                              <input
                                disabled
                                type="number"
                                className="form-control text-center"
                                value={projectDetail?.deployment}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProjectOverview;
